// @ts-nocheck
/* eslint-disable */
export const llaPlatformInventoryIcon = {
    data: `<svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4.12L7.25 7.5M1 4.12V11.1201L7.25 14.5001V7.5M1 4.12L7.25 1L13.5 4.12M13.5 4.12V8.5M13.5 4.12L7.25 7.5M15.5 11C15.5 11 13.5714 13.0893 12.6071 15.5L11 13.5714" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'inventory' as const
};